import { render } from "./IconUtilities.vue?vue&type=template&id=4c3a06fd"
const script = {}

import exportComponent from "/builds/enrian/design/design-system-documentation/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__